<script setup>
import { useI18n } from "vue-i18n";
const { t } = useI18n();
</script>
<template>
  <SkeletonLazy image-src="images/home-banner-d.jpg" ratio="1200 / 490" class="hidden md:block">
    <div
      class="absolute right-12 lg:right-32 top-[5%] lg:top-[14.5%] tracking-wide w-1/2 lg:w-[42%] text-white flex flex-col justify-between z-30"
    ></div>
  </SkeletonLazy>
  <SkeletonLazy image-src="images/home-banner-m.png" ratio="340 / 490" class="block md:hidden">
    <div
      class="absolute right-12 lg:right-32 top-[5%] lg:top-[14.5%] tracking-wide w-1/2 lg:w-[42%] text-white flex flex-col justify-between z-30"
    ></div>
  </SkeletonLazy>

  <div class="my-6 text-center md:my-10">
    <h1
      class="text-chambray-600 font-extrabold text-2xl md:text-[40px] leading-normal"
    >
      {{ t("home.mainBanner.title") }}
    </h1>
    <p
      class="text-chambray-600 font-extrabold text-2xl md:text-[40px] leading-normal"
    >
      {{ t("home.mainBanner.content") }}
    </p>
  </div>
</template>
